module.exports = __webpack_public_path__ + "img/bg.6e5a7d92.jpg";